// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xhmufnednujfyxmcznuy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhobXVmbmVkbnVqZnl4bWN6bnV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzODA4NDQsImV4cCI6MjA2Nzk1Njg0NH0.b7sn6sOCmAitLG_AAKun-BYVlB_5b5F7z8p9QcCf6OY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});